<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.activeStorageBlob')"
    resource="active_storage/blobs"
    ref="sourcePage"
  >
    <template v-slot:action>
      <MultipleUpload
        directory
        :limit="100"
        accept="*"
        :size="200"
        :title="$t('batchUpload')"
        @success="handleBatchUploadSucceed"
      />
    </template>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';
import { CONTENT_TYPES } from '@/constants';
import MultipleUpload from 'beans-admin-plugin/components/upload';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../../admin_grapes/active_storage/blobs';

@Component({
  components: {
    MultipleUpload
  }
})
export default class Blobs extends Vue {
  @Prop(String) type;

  handleBatchUploadSucceed() {
    this.$refs.sourcePage.fetchData();
  }

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    const array = [
      'filename_cont',
      {
        key: 'content_type_cont',
        renderCell: {
          component: 'select',
          props: {
            options: _.map(CONTENT_TYPES, (value) => ({ label: this.$t(`activeStorageBlob.contentTypes.${value}`), value: value })),
            clearable: true
          }
        }
      },
      {
        prop: 'tags_name_in',
        label: this.$t('model.actsAsTaggableOn/tag'),
        minWidth: 150,
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            multiple: true,
            'x-remote': {
              strategy: 'search',
              remoteMethod: async (keyword) => {
                const { data } = await this.$request.get('/acts_as_taggable_on/tags/read_options', { params: { keyword } })
                return _.map(data, ({ name }) => ({ value: name, label: name }))
              }
            }
          }
        }
      },
    ].filter(Boolean);

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'filename',
      'content_type',
      {
        key: 'url',
        minWidth: 150,
        renderCell: (h, { props: { scope: { row } } }) => {
          const imageProps = type === 'show' ? { style: 'width: 200px;height:200px' } : {};
          return <bean-resource-render
            value={row}
            imageProps={imageProps}
          />
        }
      },
      {
        prop: 'tag_list',
        label: this.$t('model.actsAsTaggableOn/tag'),
        minWidth: 150,
        renderCell: (h, { props: { value } }) => {
          return (_.map(value, (tag) => (<el-tag style={{ 'margin-right': '3px' }}>{ tag.length > 10 ? (tag.slice(0, 10) + '...') : tag }</el-tag>)))
        }
      },
      'created_at',
    ].filter(Boolean);

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'filename',
      {
        prop: 'tag_list',
        label: this.$t('model.actsAsTaggableOn/tag'),
        renderCell: {
          component: 'select',
          style: 'width: 100%',
          props: {
            clearable: true,
            multiple: true,
            'allow-create': true,
            'default-first-option': true,
            'x-remote': {
              strategy: 'search',
              remoteMethod: async (keyword) => {
                const { data } = await this.$request.get('/acts_as_taggable_on/tags/read_options', { params: { keyword: keyword } })
                return _.map(data, ({ name }) => ({ value: name, label: name }))
              }
            }
          }
        }
      },
    ];

    return formColumnsExtend(array, { data: data, type: type })
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'active_storage/blobs.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'active_storage_blobs.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}


export const route = [
  {
    path: '/active_storage/blobs',
    name: 'active_storage/blobs.index',
    component: Blobs,
    props: {
      type: 'index',
    },
    meta: {
      can: 'active_storage_blobs.read',
    },
  },
  {
    path: '/active_storage/blobs/new',
    name: 'active_storage/blobs.new',
    component: Blobs,
    props: {
      type: 'new',
    },
    meta: {
      can: 'active_storage_blobs.create',
    },
  },
  {
    path: '/active_storage/blobs/:id',
    name: 'active_storage/blobs.show',
    component: Blobs,
    props: {
      type: 'show',
    },
    meta: {
      can: 'active_storage_blobs.read',
    },
  },
  {
    path: '/active_storage/blobs/:id/edit',
    name: 'active_storage/blobs.edit',
    component: Blobs,
    props: {
      type: 'edit'
    },
    meta: {
      can: 'active_storage_blobs.update',
    },
  }
]
</script>
